import React, { useState, type SyntheticEvent } from 'react';
import { Button, TextField } from '@mui/material';

import socket from 'src/components/common/WebSocketConnection/websocket';
import { playSound } from 'src/modules/soundHandler';
import BasicBox from 'src/components/common/BasicBox';

import './JoinLobby.scss';

const JoinLobby = () => {
  const [joinGameCode, setJoinGameCode] = useState('');

  const joinLobby = (e: SyntheticEvent) => {
    e.preventDefault();
    socket.sendJSON({
      type: 'JOIN_LOBBY',
      payload: {
        joinCode: joinGameCode,
      },
    });

    playSound('selectClick');
    // Verify if code works and join game
  };

  return (
    <div className="JoinLobby">
      <BasicBox>
        <form onSubmit={joinLobby}>
          <TextField
            label="Join Code"
            value={joinGameCode}
            onChange={(e) => setJoinGameCode(e.target.value)}
            required
            size="small"
            slotProps={{
              htmlInput: {
                minLength: 6,
                maxLength: 6,
              },
            }}
          />
          <Button type="submit" variant="contained">
            Join Lobby
          </Button>
        </form>
      </BasicBox>
    </div>
  );
};

export default JoinLobby;
